import axios from "axios";
import { environment } from "@/data/environment";

const actions = {
    async getFormats({ commit, state }, { token }) {
        try {
            const { data } = await axios.get(
                `${environment.HIOPOSWEBSERVICES}/api/exogena/formats`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return data;

        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getGeneratedFormats({ commit, state }, { token, idCompany }) {
        try {
            const { data } = await axios.get(
                `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${idCompany}/formats/generated`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return Array.isArray(data) ? data : [];
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async generateFormats({ commit }, { idCompany, token, dataFilter }) {
        try {
            const params = dataFilter.formats.map(e => ({
                formatId: e,
                rangeDate: {
                    startDate: dataFilter.startDate,
                    endDate: dataFilter.endDate
                }
            }));

            const { data } = await axios.post(
                `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${idCompany}/years/${dataFilter.year}/formats-generate`,
                { formats: params },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async deleteFormat({ commit }, { idCompany, token, id, selectedTaxes }) {
        try {

            const { data } = await axios.post(
                `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${idCompany}/formatsFiles/${id}`,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
};

const mutations = {
    //
};

const state = {
    //
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};